export const mock_dashboard = {
    "dashboard_age": {
        "statall": [
            {
                "title": "\u003c18",
                "value": 1
            },
            {
                "title": "18-24",
                "value": 0
            },
            {
                "title": "25-34",
                "value": 2
            },
            {
                "title": "35-44",
                "value": 1
            },
            {
                "title": "45-54",
                "value": 2
            },
            {
                "title": "55+",
                "value": 0
            }
        ],
        "statmale": [
            {
                "title": "\u003c18",
                "value": 0
            },
            {
                "title": "18-24",
                "value": 0
            },
            {
                "title": "25-34",
                "value": 1
            },
            {
                "title": "35-44",
                "value": 0
            },
            {
                "title": "45-54",
                "value": 0
            },
            {
                "title": "55+",
                "value": 0
            }
        ],
        "statfemale": [
            {
                "title": "\u003c18",
                "value": 1
            },
            {
                "title": "18-24",
                "value": 0
            },
            {
                "title": "25-34",
                "value": 0
            },
            {
                "title": "35-44",
                "value": 1
            },
            {
                "title": "45-54",
                "value": 2
            },
            {
                "title": "55+",
                "value": 0
            }
        ],
        "statother": [
            {
                "title": "\u003c18",
                "value": 0
            },
            {
                "title": "18-24",
                "value": 0
            },
            {
                "title": "25-34",
                "value": 1
            },
            {
                "title": "35-44",
                "value": 0
            },
            {
                "title": "45-54",
                "value": 0
            },
            {
                "title": "55+",
                "value": 0
            }
        ]
    },
    "dashboard_avgorder": {
        "stat": [
            {
                "title": "AvgOrder",
                "value": 62784
            }
        ]
    },
    "dashboard_channel": {
        "stat": [
            {
                "title": "Friend Referrals",
                "value": 4
            },
            {
                "title": "Google",
                "value": 1
            },
            {
                "title": "Other",
                "value": 2
            },
            {
                "title": "Social Media",
                "value": 2
            },
            {
                "title": "Tour/Guide",
                "value": 4
            }
        ]
    },
    "dashboard_country": {
        "stat": [
            {
                "title": "ปทุมธานี",
                "value": 22
            },
            {
                "title": "ภูเก็ต",
                "value": 30
            },
            {
                "title": "นนทบรุี",
                "value": 50
            },
            {
                "title": "กรุงเทพ",
                "value": 100
            }
        ]
    },
    "dashboard_gender": {
        "stat": [
            {
                "title": "Lazada",
                "value": 6
            },
            {
                "title": "Facebook",
                "value": 6
            },
            {
                "title": "Shopee",
                "value": 1
            }
        ]
    },
    "dashboard_hearaboutus": {
        "stat": [
            {
                "title": "ทรายแมว",
                "value": 4
            },
            {
                "title": "ของเล่นแมว",
                "value": 3
            },
            {
                "title": "อาหารแมว",
                "value": 2
            },
        ]
    },
    "dashboard_ordervalue": {
        "stat": [
            {
                "title": "\u003c10,000",
                "value": 24000
            },
            {
                "title": "10,001-50,000",
                "value": 155992
            },
            {
                "title": "50,001-100,000",
                "value": 249000
            },
            {
                "title": "100,001-200,000",
                "value": 0
            },
            {
                "title": "200,001-300,000",
                "value": 0
            },
            {
                "title": "300,001+",
                "value": 499980
            }
        ]
    },
    "dashboard_register": {
        "stat": [
            {
                "date": "2025-04-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-15",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-16",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-17",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-18",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-19",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-20",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 1
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-04-21",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-22",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-23",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-24",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-25",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-26",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-04-27",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-28",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-29",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-04-30",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-15",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-16",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-17",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-18",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-19",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-20",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-21",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-22",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-05-23",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-24",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-25",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-26",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-27",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-28",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-29",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-30",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-05-31",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-06-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-15",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-16",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-17",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-18",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-19",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-20",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-21",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-22",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-23",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-24",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-25",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-26",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-27",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-28",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-29",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-06-30",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 1
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-07-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-15",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 1
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 2
                    }
                ]
            },
            {
                "date": "2025-07-16",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-17",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-18",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-19",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-20",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-21",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-22",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-23",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-24",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-25",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-26",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-27",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-28",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-29",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-30",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-07-31",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-08-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-08-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-08-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 1
                    },
                    {
                        "branch": "Shopee",
                        "value": 1
                    }
                ]
            },
            {
                "date": "2025-08-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-15",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-16",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-17",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-18",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-19",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-20",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-21",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-22",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-23",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-24",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-25",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-26",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-27",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-28",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-29",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-30",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-08-31",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-01",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 2
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 2
                    }
                ]
            },
            {
                "date": "2025-09-02",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-03",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-04",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-05",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-06",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-07",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-08",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-09",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-10",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-11",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-12",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-13",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            },
            {
                "date": "2025-09-14",
                "totalcustomer": [
                    {
                        "branch": "Lazada",
                        "value": 0
                    },
                    {
                        "branch": "Facebook",
                        "value": 0
                    },
                    {
                        "branch": "Shopee",
                        "value": 0
                    }
                ]
            }
        ]
    },
    "dashboard_repeatpurchase": {
        "stat": [
            {
                "title": "1st",
                "value": 5
            },
            {
                "title": "2nd",
                "value": 1
            },
            {
                "title": "3rd",
                "value": 0
            },
            {
                "title": "4th",
                "value": 0
            },
            {
                "title": "5th",
                "value": 0
            },
            {
                "title": "6th+",
                "value": 0
            }
        ]
    },
    "dashboard_channel": {
        "stat": [
            {
                "title": "Facebook",
                "value": 3000
            },
            {
                "title": "Lazada",
                "value": 2000
            },
            {
                "title": "Shopee",
                "value": 1500
            },
            {
                "title": "LINE",
                "value": 2500
            },
            {
                "title": "Shopify",
                "value": 1000
            },
        ]
    },
    "dashboard_summary": {
        "totalcustomer": [
            {
                "branch": "Lazada",
                "value": 5
            },
            {
                "branch": "Facebook",
                "value": 8
            },
            {
                "branch": "Shopee",
                "value": 13
            }
        ],
        "totalsale": [
            {
                "branch": "Lazada",
                "value": 206000
            },
            {
                "branch": "Facebook",
                "value": 672972
            },
            {
                "branch": "Shopee",
                "value": 878972
            }
        ]
    },
    "dashboard_topselling": {
        "stat": [
            {
                "title": "Suit",
                "value": 27
            },
            {
                "title": "Jacket",
                "value": 7
            },
            {
                "title": "Skirt",
                "value": 4
            },
            {
                "title": "Blazer",
                "value": 17
            },
            {
                "title": "Blouse",
                "value": 6
            },
            {
                "title": "Shirt",
                "value": 14
            },
            {
                "title": "Dress",
                "value": 5
            },
            {
                "title": "Pants",
                "value": 9
            },
            {
                "title": "Vest",
                "value": 6
            },
            {
                "title": "Shoe",
                "value": 5
            },
            {
                "title": "Accessory",
                "value": 14
            }
        ]
    },
    "dashboard_topspender": [
        {
            "profileid": "5409D86A-229A-11F0-9908-005056011908",
            "firstname": "Siwaporn",
            "lastname": "Sornz",
            "repeatpurchase": 2,
            "totalspending": 549980
        },
        {
            "profileid": "1769FD84-5FE1-11F0-BC2F-005056011908",
            "firstname": "pok",
            "lastname": "test2",
            "repeatpurchase": 1,
            "totalspending": 100000
        },
        {
            "profileid": "BFC75994-36B4-11F0-9908-005056011908",
            "firstname": "Pok-client",
            "lastname": "Teatt",
            "repeatpurchase": 1,
            "totalspending": 99000
        },
        {
            "profileid": "08D87840-613A-11F0-BC2F-005056011908",
            "firstname": "pok-test",
            "lastname": "client",
            "repeatpurchase": 1,
            "totalspending": 29992
        },
        {
            "profileid": "DA83C481-1D59-11F0-8CC7-025041000001",
            "firstname": "สุฑี2+1",
            "lastname": "เกตุพันธุ์2+1",
            "repeatpurchase": 1,
            "totalspending": 20000
        },
        {
            "profileid": "C788911B-614B-11F0-BC2F-005056011908",
            "firstname": "siwapoen09",
            "lastname": "test",
            "repeatpurchase": 1,
            "totalspending": 5000
        }
    ],
    "result": "complete",
    "resultcode": "",
    "resultdetail": ""
}